import React from 'react';
import { Button } from '../../../components/base/Button';

export const ServicesSection: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>專業服務項目</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            焯峯工程提供全方位的建築工程技術服務，包括<strong>村屋僭建物申報</strong>、<strong>TCP T1</strong>、<strong>TCP T3</strong>、<strong>BD T1</strong>、<strong>BD T3</strong>、<strong>RSE T3</strong>及<strong>國內T1</strong>適任技術人員註冊，確保您的項目符合香港屋宇署的最新規定
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* 村屋僭建物申報及安全檢驗 */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="p-6">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-home-4-line text-2xl text-red-600"></i>
              </div>
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/7e998c768322e0ceba02ee8b736d70d3.jpeg"
                alt="村屋僭建物申報及安全檢驗"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3">村屋僭建物申報及安全檢驗</h3>
              <p className="text-gray-600 mb-4">
                專業處理<strong>村屋僭建物申報</strong>程序，提供結構安全證明報告，確保符合屋宇署要求。服務涵蓋<strong>BD T1</strong>及<strong>BD T3</strong>監督範疇。
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  簡單六步完成申報
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  結構安全證明報告
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  五年一次續期檢驗
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  14工作天完成流程
                </li>
              </ul>
              <Button href="/village-house-declaration" className="w-full">
                了解詳情
              </Button>
            </div>
          </div>

          {/* T1適任技術人員註冊 */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="p-6">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-2xl text-red-600"></i>
              </div>
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/8e2a0b8058c3b3d3142c13e611b3cb2d.jpeg"
                alt="TCP T1 BD T1 國內T1適任技術人員註冊"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3">TCP T1 / BD T1 / 國內T1 適任技術人員註冊</h3>
              <p className="text-gray-600 mb-4">
                提供<strong>TCP T1</strong>、<strong>BD T1</strong>及<strong>國內T1</strong>適任技術人員註冊服務，專業監督小型工程項目，確保工程質量和安全。
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  香港工程TCP T1監督
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  國內工廠物料生產監督
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  玻璃熱浸監督和報告
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  專業技術支援
                </li>
              </ul>
              <Button href="/t1-technician" className="w-full">
                了解詳情
              </Button>
            </div>
          </div>

          {/* T3適任技術人員註冊 */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="p-6">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-red-600"></i>
              </div>
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/5e809fe16ba712521c83d2a330a45870.jpeg"
                alt="TCP T3 BD T3 RSE T3適任技術人員註冊"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3">TCP T3 / BD T3 / RSE T3 適任技術人員註冊</h3>
              <p className="text-gray-600 mb-4">
                專業<strong>TCP T3</strong>、<strong>BD T3</strong>及<strong>RSE T3</strong>適任技術人員註冊，負責大型建築工程監督，提供全面的技術支援服務。
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  本地建築工程TCP T3監督
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  國內工廠T3監督
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  大型工程項目管理
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-red-600 mr-2"></i>
                  專業技術評估
                </li>
              </ul>
              <Button href="/t3-technician" className="w-full">
                了解詳情
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
